import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useToast } from 'context/ToastContext';
import * as apiWarehouses from 'api/apiWarehouses';
import WarehouseApiIdentForm from './WarehouseApiIdentForm';

interface WarehouseApiIdentFormikProps {
    setShow: (show: boolean) => void;
    warehouseId: number;
    warehouseIdApi?: string | null;
    onSaved: () => Promise<void>;
}

const WarehouseApiIdentFormik = ({
    setShow,
    warehouseId,
    warehouseIdApi,
    onSaved,
}: WarehouseApiIdentFormikProps) => {
    const { t } = useTranslation(['Warehouses', 'common']);
    const { showToast } = useToast();

    return (
        <Formik
            enableReinitialize
            initialValues={{ warehouseIdApi: warehouseIdApi || '' }}
            onSubmit={async (values, { setFieldError }) => {
                const res = await apiWarehouses.setWarehouseIdApi(warehouseId, values.warehouseIdApi);
                if (res?.stat) {
                    await onSaved();
                    setShow(false);
                    showToast(t('apiIdent.messSaved'), 'success');
                    return;
                }

                if (res?.errCode === 'DUPLICATE_IDENT') {
                    setFieldError('warehouseIdApi', t('apiIdent.messDuplicate'));
                    return;
                }

                if (res?.errCode === 'TOO_LONG') {
                    setFieldError('warehouseIdApi', t('apiIdent.messTooLong'));
                    return;
                }

                showToast(t('common:messError'), 'danger');
            }}
        >
            {({ handleSubmit, isSubmitting, errors, touched }) => (
                <WarehouseApiIdentForm
                    handleSubmit={handleSubmit}
                    isSubmitting={isSubmitting}
                    error={touched.warehouseIdApi && errors.warehouseIdApi ? String(errors.warehouseIdApi) : ''}
                />
            )}
        </Formik>
    );
};

export default WarehouseApiIdentFormik;
